<script>
export default {
  name: 'Admin',
  created() {
    this.$store.dispatch('configNavigation', {leftEnabled: true, leftRoute: 'dashboard', leftImg: 'icon-back.svg'});
  }
}
</script>
<template>
  <div class="page">
    <div class="padded">
      <ul>
        <li><router-link :to="{name: 'adminUsers'}">Users</router-link></li>
      </ul>
      <router-view></router-view>
    </div>
  </div>
</template>
